import { CartItems } from '@/scripts/cart/cart-items'
import { SELECTORS } from '@/scripts/core/global'

export class CartDrawerItems extends CartItems {
	static override htmlSelector = 'cart-drawer-items'
	static override selectors = {
		...CartItems.selectors,
		element: 'cart-drawer-items',
		lineItemStatus: '[data-uc-cart-drawer-status]',
		errors: '[data-uc-cart-drawer-errors]',
		liveRegionText: '[data-uc-cart-drawer-live-region-text]',
		main: '[data-uc-cart-drawer-main]',
		// the following selectors are partial - they will be concatenated with the line ID
		line: '#CartDrawer-Item', // ex: `${this.instanceSelectors.line}-${line}`
		lineQuantity: '#CartDrawer-Quantity', // ex: `${this.instanceSelectors.lineQuantity}-${line}`
		lineError: '#CartDrawer-LineItemError', // ex: `${this.instanceSelectors.lineError}-${line}`
	}
	orderClock?: number
	timeFormatter = new Intl.DateTimeFormat('en-US', {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true,
		timeZoneName: 'short',
	})
	dateFormatter = new Intl.DateTimeFormat('en-US', {
		weekday: 'long',
		month: 'long',
		day: 'numeric',
		year: 'numeric',
	})
	constructor() {
		super()
	}
	override connectedCallback() {
		super.connectedCallback()
		if (!this.querySelector('[data-order-time]')) return
		this.updateOrderDateTime()
		this.orderClock = window.setInterval(() => this.updateOrderDateTime(), 30_000)
	}
	override disconnectedCallback() {
		window.clearInterval(this.orderClock)
		super.disconnectedCallback()
	}
	updateOrderDateTime() {
		const now = new Date()
		const orderTime = this.querySelector<HTMLElement>('[data-order-time]')
		const orderDate = this.querySelector<HTMLElement>('[data-order-date]')
		if (orderTime) orderTime.textContent = this.timeFormatter.format(now)
		if (orderDate) {
			orderDate.textContent = this.dateFormatter.format(now).toUpperCase()
		}
	}
	override setInstanceSelectors() {
		this.instanceSelectors = CartDrawerItems.selectors
	}
	override getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer-items',
				selector: 'cart-drawer-items',
			},
			{
				id: 'CartIconBubble',
				section: 'cart-icon-bubble',
				selector: SELECTORS.cartLink,
			},
			{
				id: 'CartDrawer',
				section: 'dynamic-cart-footer',
				selector: '.cart-drawer__footer',
			},
		]
	}
}
